var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.272 15.224a7.404 7.404 0 1 1 .794-.77l.943.873.77.049 5.351 5.361-1.475 1.475-5.357-5.355-.046-.773zm.987-5.69a5.676 5.676 0 1 1-11.352 0 5.676 5.676 0 0 1 11.352 0",
    clipRule: "evenodd"
  })));
};
export default SvgSearch;